export type SizeRange = {
  [key: string]: {
    gte: number;
    lte?: number;
  };
};

export const SIZES_RANGE: SizeRange = {
  '0 - 200': { gte: 0, lte: 200 },
  '200 - 300': { gte: 200, lte: 300 },
  '300 - 400': { gte: 300, lte: 400 },
  '400 - 500': { gte: 400, lte: 500 },
  '500 - 600': { gte: 500, lte: 600 },
  '600 - 700': { gte: 600, lte: 700 },
  '700 - 800': { gte: 700, lte: 800 },
  '800 - 900': { gte: 800, lte: 900 },
  '900 - 1000': { gte: 900, lte: 1000 },
  '1000 - 1100': { gte: 1000, lte: 1100 },
  '1100 - 1200': { gte: 1100, lte: 1200 },
  '1200+': { gte: 1200 },
};
